function App() {
  return (
    <div className="App">
      <section className="App h-screen w-full flex justify-center items-center bg-green-500">
        <p className="text-7xl">🍁 Curiomind</p>
     <p className="text-3xl">An excellece center for education</p>
      </section>
    </div>
  );
}

export default App;
